// Which "Hidden. Undo" toast is showing: one at a time, the newest hide replaces the one before.
import { createStore, useStore } from "zustand";
import type { NowishEvent } from "../../shared/rules";
import { HideSession } from "../../profile/hide";
import { getProfile } from "../../state/profile";

export const hideToastStore = createStore<{ session: HideSession | null; leaving: boolean }>()(() => ({ session: null, leaving: false }));
export const useHideToast = () => useStore(hideToastStore);

export function hideWithToast(e: NowishEvent): void {
  hideToastStore.setState({ session: new HideSession(getProfile(), e), leaving: false });
}
export const dismissHideToast = () => { if (hideToastStore.getState().session) hideToastStore.setState({ leaving: true }); };
export const removeHideToast = () => hideToastStore.setState({ session: null, leaving: false });

// The browser tests hide an event the way the card's button does (the card itself belongs to another slice).
const w = window as unknown as { nowishDebug?: Record<string, unknown> };
w.nowishDebug = { ...w.nowishDebug, hideWithToast };
